
const run = () => {
  // Apparently we do not want to run com score on video pages
  if (window.location.href.match(/^\/video/)) {
    return;
  }

  let url = (document.location.protocol == 'https:' ? 'https://sb' : 'http://b') + '.scorecardresearch.com/p?';

  let params = {
    c1: 2,                                       // content type sort of thing. 1 => video, 2 => story
    c2: 6035223,                                 // publisher id
    c7: $("link[rel='canonical']").attr("href"), // canonical url
    c8: document.title,                          // title
    comscorekw: window.js_vars.category          // comma-seperated keywords?
  }

  let qsp = []
  Object.keys(params).forEach(key => {
    qsp.push(`${key}=${encodeURIComponent(params[key])}`);
  });
  url += qsp.join("&");

  let pixel = new Image();
  pixel.id = "comscore";
  pixel.src = url;
}

export default Object.freeze({ run });
